export const DEFAULT_CONTROL_PAGE_TAB = "overview";

export const CONTROL_PAGE_TAB_IDS = [
  "overview",
  "second-line",
  "evidence",
  "testing",
  "applicability",
  "activity",
];

export function isValidControlPageTab(tab) {
  if (!tab) return false;
  return CONTROL_PAGE_TAB_IDS.includes(tab);
}

export function controlPagePath(id, tab = DEFAULT_CONTROL_PAGE_TAB) {
  const safeTab = isValidControlPageTab(tab) ? tab : DEFAULT_CONTROL_PAGE_TAB;
  return `/control_overview/${id}/${safeTab}`;
}

export function parseControlPageLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "control_overview" || !parts[1]) {
    return { id: null, tab: DEFAULT_CONTROL_PAGE_TAB };
  }
  const tab = parts[2] || DEFAULT_CONTROL_PAGE_TAB;
  return {
    id: parts[1],
    tab: isValidControlPageTab(tab) ? tab : DEFAULT_CONTROL_PAGE_TAB,
  };
}
